import config from '../../config/dev'

export default (relativePath) => {
  return `${config.hostUrl}${relativePath}`
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/full_path.js
 **/